

const LandingPage = () => {

    return (
        <div>
            {/* Start Hero section */}
            <section id={"/home"} className=" w-full mt-[100px]">
                <img className=" h-screen md:h-auto object-cover md:object-fill" src="Hero.jpg" title="DaweiDriverTeam" />
            </section>
            {/* End Hero Section */}

            {/* Start About us section */}
            <section id={"/about"}>
                <div className=" px-[20px] md:px-[200px] text-center mt-[100px]">
                    <h3 className=" mt-2 text-xl font-semibold">
                        ကျွန်ုပ်တို့၏အကြောင်း (About Us)
                    </h3>
                    <p className=" mt-5 text-black-50 break-words">
                        "Driver Team Ride-Hailing Company Limited ကို ထားဝယ်တွင် သယ်ယူပို့ဆောင်ရေးဝန်ဆောင်မှုများပေးဆောင်ရန် တည်ထောင်ခဲ့ပါသည်။ သုံးဘီးတပ် (Tuk Tuks) နှင့် တိုးပွားလာသော ရေယာဉ်စုကို အသုံးပြု၍ လူများနှင့် နေရာများကို တစ်နှစ်ကျော်ကြာ ချိတ်ဆက်ပေးခဲ့ပါသည်။"
                    </p>
                </div>

                <div className=" mt-20 divider"></div>

                <div className="mt-20 px-[20px] md:px-[200px] grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-6 flex justify-center">
                        <img src={"mission.svg"} alt="Mission" />
                    </div>
                    <div className="col-span-12 md:col-span-6 flex justify-center mt-10 md:mt-0">
                        <img src={"mission-1.svg"} alt="Mission 1" />
                    </div>
                </div>

                <div className=" mt-20 divider"></div>

                <div className="mt-20 px-[20px] md:px-[200px] grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-6 flex justify-center">
                        <img src={"vision-1.svg"} alt="Mission" />
                    </div>
                    <div className="col-span-12 md:col-span-6 flex justify-center mt-10 md:mt-0">
                        <img src={"vision.svg"} alt="Mission 1" />
                    </div>
                </div>

                <div className=" mt-20 divider"></div>

            </section>
            {/* End About us section */}

            {/* Start Service section */}
            <section id={'/service'}>

                <div className=" text-center mt-[100px]">
                    <h1 className=" text-2xl font-semibold"> ၀န်ဆောင်မှုများ </h1>
                    <h3 className=" text-xl font-semibold mt-4">{"(Our Services)"}</h3>
                </div>

                <div className=" px-[30px] mt-[100px] grid grid-cols-12 gap-4">

                    <div className="col-span-12 md:col-span-3 flex justify-center">
                        <div className=" w-full h-[250px] md:h-[180px] xl:h-[250px] bg-primary rounded-[20px] p-5">
                            <img src={"trust.svg"} />

                            <img src={"trust-text.svg"} className="mt-5" />
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-3 flex justify-center">
                        <div className=" w-full h-[250px] md:h-[180px] xl:h-[250px] bg-primary rounded-[20px] p-5">
                            <img src={"rate.svg"} />

                            <img src={"rate-text.svg"} className="mt-5" />

                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-3 flex justify-center">
                        <div className=" w-full h-[250px] md:h-[180px] xl:h-[250px] bg-primary rounded-[20px] p-5">
                            <img src={"secure.svg"} />

                            <img src={"secure-text.svg"} className="mt-5" />

                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-3 flex justify-center">
                        <div className=" w-full h-[250px] md:h-[180px] xl:h-[250px] bg-primary rounded-[20px] p-5">
                            <img src={"first.svg"} />

                            <img src={"first-text.svg"} className="mt-5" />

                        </div>
                    </div>

                </div>

            </section>
            {/* End Service section */}

            {/* Start Download section */}
            <section id={'/download'} className=" px-[30px] md:px-[120px] py-[80px] bg-primary mt-[100px]">
                <div className=" grid grid-cols-12 gap-4">
                    <div className=" col-span-12 md:col-span-8 flex justify-start">
                        <div className="">
                            <h3 className=" text-white text-xl font-bold"> အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ။ </h3>
                            <img src={"play-store.svg"} className=" mt-5 w-[273px] h-[40px]" />
                            {/* <h4 className="text-3xl text-white font-semibold mt-5">Get A Free Driver Team Ride-Hailing App <br />
                                From Online Store</h4> */}
                            <p className=" md:w-[300px] xl:w-[400px] text-white text-xl mt-3">
                                Google Play Store နှင့် Apple Store တို့တွင် Driver Team Dawei App ကို Download ဆွဲပြီး ကျွန်ပ်တို့၏ ၀န်ဆောင်မှုများကို ထိတွေခံစားနိုင်ပါပြီး
                            </p>
                        </div>
                    </div>
                    <div className=" col-span-12 md:col-span-4 flex justify-center">
                        <img src={"showcase.svg"} className="" />
                    </div>
                </div>
            </section>
            {/* End Download section */}

            {/* Start App Feature section */}
            <section className=" bg-[#F1F1F1] md:px-[80px] xl:px-[120px] py-[50px]">

                <div className=" grid grid-cols-12 gap-4 px-[30px] md:px-0">

                    <div className=" col-span-12 md:col-span-6">
                        <div className="">
                            <h2 className=" text-2xl font-semibold"> အက်ပ်အင်္ဂါရပ်များ (Features) </h2>
                        </div>
                        <div className=" mt-10">
                            <img src={"dtw_img01.png"} style={{ borderRadius: "20px" }} />
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-6">
                        <div className=" grid grid-cols-12 gap-4 md:gap-8">

                            <div className=" col-span-12 md:col-span-6">
                                <div className=" mt-14 grid grid-cols-12 gap-3 xl:gap-5">

                                    <div className=" col-span-12">
                                        <div className="w-full md:max-w-[200px] xl:max-w-[300px] min-h-[203px] bg-primary rounded-[20px] py-7">
                                            <img className="mx-auto" src={'toke-face.svg'} />
                                            <img className="mx-auto mt-3" src={"feature-first.svg"} />
                                        </div>
                                    </div>

                                    <div className=" col-span-12">
                                        <div className="w-full md:max-w-[200px] xl:max-w-[300px] min-h-[203px] bg-primary rounded-[20px] py-7">
                                            <img className="mx-auto" src={'toke-face.svg'} />
                                            <img className="mx-auto mt-3" src={"feature-sec.svg"} />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-span-12 md:col-span-6">

                                <div className=" grid grid-cols-12 gap-4 xl:gap-5">
                                    <div className=" col-span-12">
                                        <div className="w-full md:max-w-[200px] xl:max-w-[300px] min-h-[203px] bg-primary rounded-[20px] py-7">
                                            <img className="mx-auto" src={'toke-face.svg'} />
                                            <img className="mx-auto mt-3" src={"feature-third.svg"} />
                                        </div>
                                    </div>

                                    <div className=" col-span-12">
                                        <div className="w-full md:max-w-[200px] xl:max-w-[300px] min-h-[203px] bg-primary rounded-[20px] py-7">
                                            <img className="mx-auto" src={'toke-face.svg'} />
                                            <img className="mx-auto mt-3" src={"feature-four.svg"} />
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

            </section>
            {/* End App Feature section */}

            {/* Start Thet Tay Kan section */}
            <section className=" px-[30px]">

                <div className=" mt-[50px]">
                    <img src={"thet-tay-kan.svg"} />
                </div>

                <div className=" mt-[30px] grid grid-cols-12 gap-4 md:gap-8">

                    <div className=" col-span-12 md:col-span-6">
                        <div className=" bg-primary rounded-[20px] overflow-hidden">
                            <img className=" w-full" src={"img01.png"} />
                            <p className=" p-[30px] break-words text-white">"Driver Team သည် ထားဝယ်တွင် ကျွန်ုပ်၏သွားလာပုံကို လုံးဝပြောင်းလဲသွားပါသည်။ ဘေးကင်းသည်၊ တတ်နိုင်သည်၊ အချိန်မှန်သည်"
                            </p>
                        </div>
                    </div>
                    <div className=" col-span-12 md:col-span-6">
                        <div className=" bg-primary rounded-[20px] overflow-hidden">
                            <img className=" w-full" src={"img02.png"} />
                            <p className=" p-[30px] break-words text-white">
                                "အက်ပလီကေးရှင်းက သုံးရတာ အရမ်းလွယ်ကူပြီး ယာဉ်မောင်းတွေက ဖော်ရွေပါတယ်။ ဒီဝန်ဆောင်မှုကို အထူးအကြံပြုလိုပါတယ်။"
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Ther Tay Kan section */}

            {/* Start Contact section */}
            <section id={'/contact'} className=" px-[30px] mt-[50px]">
                <div className=" text-center">
                    <h3 className=" font-semibold text-xl"> ဆက်သွယ်ရန်  </h3>
                    <h4 className=" font-bold text-2xl">{"(Contact Us)"}</h4>
                </div>
                <img className=" mt-[30px]" src={"about-us.svg"} />

                <div className=" grid grid-cols-12 gap-4 mt-[30px]">

                    <div className=" col-span-12 md:col-span-6">

                        <div className=" bg-[#F1F1F1] rounded-[20px] p-[20px]">

                            <div className=" mt-5 flex items-center justify-start gap-4">
                                <img src={"phone-call.svg"} />
                                <p className=" font-semibold">(+95) 9882577171</p>
                            </div>

                            <div className=" mt-5 flex items-center justify-start gap-4">
                                <img src={"mail.svg"} />
                                <p className=" font-semibold"> support@driverteamdawei.com </p>
                            </div>

                            <div className=" mt-5 flex items-center justify-start gap-4">
                                <img src={"gps.svg"} />
                                <p className=" font-semibold"> 791၊ ကမ်းနားလမ်း၊ ထားဝယ်၊ မြန်မာ </p>
                            </div>

                            <div className=" mt-5 flex items-center justify-start gap-4">
                                <img src={"facebook.svg"} />
                                <a className="font-semibold" href="https://www.facebook.com/share/1B2gQvaE9h" target="_blank"> Driver Team Taxi </a>
                            </div>

                        </div>

                        <div className="mt-10">
                            <img src={"about-us-img.svg"} />
                        </div>

                    </div>

                    <div className=" col-span-12 md:col-span-6 mt-10 md:mt-0">

                        <div className="bg-[#F1F1F1] rounded-[20px] p-[20px] py-[30px]">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61918.75918096761!2d98.15545912693511!3d14.08175515421573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e50ba0a8e3d66f%3A0x3c97b1b636636978!2sDriver%20Team%20tuk%20tuk%20taxi!5e0!3m2!1sen!2smm!4v1737168746676!5m2!1sen!2smm" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>

                    </div>

                </div>

            </section>
            {/* End Contact section */}
        </div>
    )

}

export default LandingPage;